module.exports = __webpack_public_path__ + "static/media/my-videos.34a5d946.svg";